import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
    IconButton,
} from "@material-ui/core";
import {
    Add,
    Edit,
    Delete,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { showAddItemStatusDialog } from "../item-status-add/item-status-add-slice"
import { useEffect } from "react";
import { db } from "../../../../firebase";
import { showEditItemStatusDialog } from "../item-status-edit/item-status-edit-slice";
import { showDeleteItemStatusDialog } from "../item-status-delete/item-status-delete-slice";
import { getItemStatusService } from "./item-status-list-service";
import ItemStatusListLoading from "./item-status-list-loading";
import ItemStatusListEmpty from "./item-status-list-empty";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
        background: "#111111",
        height: "100%",
        color: "#fbbbd3",
        fontSize: 14,
    },
    button: {
        background: "#111111",
        color: "#fbbbd3",
        justifyContent: "right",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        color:"#111111",
        marginBottom: 20,
    }
}));


const ItemStatusList = () => {
    const classes = useStyles();
    const itemStatusCollection = useSelector((state) => state.itemStatusListSlice.rows);
    const isLoading = useSelector((state) => state.itemStatusListSlice.isLoading);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        const fetchData = async () => {
            try {
                await getItemStatusService(dispatch, db, "item_status");
            } catch(e) {
                dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
                console.error("ItemStatusList fetchData error: ", e);
            }
        };
        fetchData();
    }, [dispatch]);

    // open add dialog
    const handleAddOpen = () => {
        dispatch(showAddItemStatusDialog());
    };

    // open edit dialog
    const handleEditOpen = (row) => {
        dispatch(showEditItemStatusDialog(row));
    };

    // open delete dialog
    const handleDeleteOpen = (row) => {
        dispatch(showDeleteItemStatusDialog(row));
    };

    // return loading state if isLoading is true
    if (isLoading) {
        return <ItemStatusListLoading/>
    }

    // return empty state if isLoading is false and itemStatusCollection has no collection
    if (!isLoading && itemStatusCollection.length === 0) {
        return <ItemStatusListEmpty/>
    }

    return (
        <>
            <Typography className={classes.title} variant="h4">Item Status</Typography>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<Add/>}
                    onClick={handleAddOpen}
                >
                    Add
                </Button>
            </div>
            
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" className={classes.tableHeader}>Code</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Name</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Description</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itemStatusCollection.map((row) => (
                            <TableRow key={row.code}>
                                <TableCell component="th" scope="row">
                                    {row.code}
                                </TableCell>
                                <TableCell align="right">{row.name}</TableCell>
                                <TableCell align="right">{row.description}</TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        className={classes.buttonText}
                                        onClick={() => handleEditOpen(row)}
                                    >
                                        <Edit/>
                                    </IconButton>
                                    <IconButton
                                        className={classes.buttonText}
                                        onClick={() => handleDeleteOpen(row)}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default ItemStatusList;